if (!customElements.get('component-product-size-chart')) {
  customElements.define('component-product-size-chart', class ProductSizeGuide extends HTMLElement {
    constructor() {
      super();
      this.props = {
        type: this.dataset.type,
        title: this.dataset.title,
        id: this.dataset.id,
        vendor: this.dataset.vendor,
        tags: this.dataset.tags,
        sizeChartType: this.dataset.sizeChartType,
        showMultipleCharts: this.dataset.showMultipleCharts === 'true',
        src: this.dataset.src
      }
      this.render();
    }
    async render() {
      const buttonTemplate = this.querySelector('.js-template-button').content.cloneNode(true);
      const modalTemplate = this.querySelector('.js-template-modal').content.cloneNode(true);
      // Handle multiple size charts on bundle pdps
      if (this.props.showMultipleCharts && this.props.sizeChartType) {
        const chartTitle = this.getChartTitle(this.props.sizeChartType);
        buttonTemplate.querySelector('.js-size-chart-text').innerHTML = chartTitle;
        buttonTemplate.querySelector('.js-size-chart-svg').remove();
        buttonTemplate.querySelector('.js-size-chart-text').classList.add('size-chart-text--multiple-charts');
      }
      // Render button
      this.appendChild(buttonTemplate);
      // Get and render size guide within modal
      let sizeChartType;
      if (this.props.sizeChartType) {
        sizeChartType = this.props.sizeChartType;
      } else if (this.props.type && this.props.title && this.props.vendor && this.props.tags) {
        sizeChartType = getSizeChartType(this.props.type.toLowerCase(), this.props.title.toLowerCase(), this.props.vendor.toLowerCase(), this.props.tags.toLowerCase());
      }
      let sizeGuide = await this.getSizeGuide(sizeChartType);
      if (sizeGuide) {
        const chartTitle = this.getChartTitle(sizeChartType, this.props.title);
        if (modalTemplate.querySelector('.js-size-chart-modal-content')) modalTemplate.querySelector('.js-size-chart-modal-content').appendChild(sizeGuide.body.querySelector(`#${sizeChartType}-size-guide`));
        if (modalTemplate.querySelector('.js-size-chart-modal-title')) modalTemplate.querySelector('.js-size-chart-modal-title').textContent = `${chartTitle} ${chartTitle === 'Wireless Precise' ? 'Sizing™ Guide' : 'Size Guide'}`;
        if (sizeChartType === 'bra' || (this.props.type?.toLowerCase() === 'sleepwear' && this.props.tags?.includes('filter_style:Wireless'))) {
          modalTemplate.querySelector('.js-size-chart-modal-content component-bra-calculator').classList.remove('hidden');
        }
        if (chartTitle === 'underwear') {
          modalTemplate.querySelector('.fit-quiz-cta a').classList.add('hidden');
        }
      } else {
        this.querySelector('.js-size-chart-btn').remove();
      }
      this.appendChild(modalTemplate);
      this.afterRender(sizeChartType);
    }
    getChartTitle(type = '', title = '') {
      if (type.includes('kit_undergarments_')) {
        return type.replace('kit_undergarments_', '');
      } else if (type.includes('formfit')) {
        if (title.includes('Form 360')) {
          return 'Form 360 Fit™';
        } else {
          return 'Wireless Precise';
        }
      } else if (type === 'wireless' && title.toLowerCase().includes('bralette')) {
        return 'Bralette';
      } else if (title?.toLowerCase().includes('nippies')) {
        return 'Nipple Covers';
      }
      return type;
    }
    async getSizeGuide(type) {
      // Get size guide from page based on product type (page.size-guide-content.liquid)
      if (type) {
        let response = await fetch(`${window.Shopify.routes.root}pages/${type}-size-chart?view=size-guide-content`, {
          method: "get"
        });
        response = await response.text();
        return new DOMParser().parseFromString(response, 'text/html');
      }
    }
    afterRender(sizeChartType) {
      if (this.querySelector('.js-size-chart-btn')) {
        this.querySelector('.js-size-chart-btn').addEventListener('click', (event) => {
          event.preventDefault();
          this.querySelector('.js-size-chart-modal').classList.toggle('hidden');
          document.querySelector('body').classList.add('overflow-hidden');
          this.sendSizeChartGTMData(sizeChartType);
        });
        this.querySelector('.js-size-chart-modal-close').addEventListener('click', (event) => {
          event.preventDefault();
          this.querySelector('.js-size-chart-modal').classList.add('hidden');
          document.querySelector('body').classList.remove('overflow-hidden');
        });
        this.querySelector('.js-size-chart-modal-overlay').addEventListener('click', (event) => {
          if (event.target.classList.contains('js-size-chart-modal-overlay')) {
            this.querySelector('.js-size-chart-modal').classList.add('hidden');
            document.querySelector('body').classList.remove('overflow-hidden');
          }
        });
      }
    }
    sendSizeChartGTMData(sizeChartType) {
      window.sendGTMData && window.sendGTMData({
        event: 'pdp_size_chart_click',
        product_id: this.props.id,
        size_chart_viewed: sizeChartType,
        source: this.props.src
      });
    }
  });
}
